import { useId } from "react";
import PropTypes from "prop-types";

import { priceFormatter } from "helpers/number-formatter";

import Title from "components/listing-detail/title";
import MoreContent from "components/listing-detail/more-content";
import Unit from "@/src/utils/constants/units";

import styles from "./styles.module.css";

const InfoList = ({ data, isDailyRentPage }) => {
  const id = useId();
  const visibleContentHeightForDailyRentPage = 215;
  /* const visibleContentHeightForOtherPages = 131;
  const moreContentHeight = isDailyRentPage ? visibleContentHeightForDailyRentPage : visibleContentHeightForOtherPages; */
  const getValue = (p) => {
    if (p.key === "square_meter_price") {
      const value = parseFloat(p.value?.replace(/[^0-9,.]/g, ""));
      return `${priceFormatter(value)} TL/${Unit.M2.name}`;
    }
    return p.value;
  };
  return (
    <div className={styles.wrapper} id="ilan-hakkinda" data-scroll-selector>
      <Title>İlan Bilgileri</Title>
      <MoreContent defaultHeight={visibleContentHeightForDailyRentPage}>
        <ul>
          {data
            .filter((x) => x.value !== null)
            .map((item, index) => (
              <li key={`${id}-${index}`}>
                <span className={styles.key}>{item.name}</span>
                <span className={styles.value}>{getValue(item)}</span>
              </li>
            ))}
        </ul>
      </MoreContent>
    </div>
  );
};

InfoList.propTypes = {
  data: PropTypes.array.isRequired,
  isDailyRentPage: PropTypes.bool,
};

export default InfoList;
